import { render } from "./OrdersShow.vue?vue&type=template&id=ffe8e718"
import script from "./OrdersShow.vue?vue&type=script&lang=js"
export * from "./OrdersShow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__